import { Component, Input, ViewChild } from '@angular/core';
import { Product } from '@/app/shared/interface/product.interface';
import { Cart, CartItem } from '@/app/shared/interface/cart.interface';
import { CommonService } from '@/app/shared/services/common.service';
import { Router } from '@angular/router';
import { WishlistService } from '../../services/wishlist.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { Voucher } from '@/app/shared/interface/voucher.interface';
import { ListBanners } from '../../interface/banner.interface';
// import { LoginModalComponent } from '../login-modal/login-modal.component';
// import { RegistryModalComponent } from '../registry-modal/registry-modal.component';
// import { ForgotPasswordModalComponent } from '../forgot-password-modal/forgot-password-modal.component';

@Component({
  selector: 'app-product-information',
  templateUrl: './product-information.component.html',
  styleUrls: ['./product-information.component.scss'],
})
export class ProductInformationComponent {
  @ViewChild('voucherModal', { static: false }) voucherModal: any;

  @Input() product: Product;
  @Input() isAuthenticated: boolean = false;
  @Input() vouchers: Voucher[] = [];
  @Input() productSuggestions: Product[] = [];
  @Input() productVouchers: Voucher[] = [];
  @Input() selectedVoucherCode: string[] = [];
  @Input() cart: Cart;
  @Input() productBanner: ListBanners | undefined;
  @Input() productPolicy: any[] = [];

  // @ViewChild("loginModal") LoginModal: LoginModalComponent;
  // @ViewChild("registryModal") RegistryModal: RegistryModalComponent;
  // @ViewChild("forgotPasswordModal") ForgotPasswordModal: ForgotPasswordModalComponent;

  inWishList: boolean = false;
  isAccountActivated: boolean = false;

  constructor(
    private commonService: CommonService,
    private wishlistService: WishlistService,
    private toastService: ToastrService,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
    if (this.isAuthenticated) {
      this.isAccountActivated = this.authService.isAccountActivated();
    }
    this.commonService.getCategories.subscribe({
      next: (res: any[]) => {
        if (res) {
          const allCategories = this.findAllCategories(res);

          const slugs = this.product.categories
            .map(
              (c) =>
                allCategories.find((fc) => fc.categoryId === c.categoryId)
                  ?.slug,
            )
            .filter(Boolean);
          const productInfo = this.product.productInfo.find(
            (p) => p.type === 0,
          );
          if (productInfo) {
            productInfo.path =
              'product?category=' +
              slugs.map((s) => encodeURIComponent(s)).join(',');
          }
        }
      },
      error: (error) => {
        console.error(error);
      },
    });

    this.commonService.getWishlist.subscribe({
      next: (res: number[]) => {
        if (res && res.length > 0) {
          for (let id of res) {
            if (id == this.product.productID) {
              this.inWishList = true;
            }
          }
        }
      },
    });
  }

  findAllCategories(categories: any[]): any[] {
    return categories.reduce((acc: any[], curr: any) => {
      acc.push(curr);
      if (curr.children?.length) {
        acc.push(...this.findAllCategories(curr.children));
      }
      return acc;
    }, []);
  }

  goto(link: string) {
    this.router.navigateByUrl(link);
  }

  addToWishlist(id: number) {
    this.inWishList = !this.inWishList;
    const body = {
      productId: id,
    };
    this.wishlistService.addWishlist(JSON.stringify(body)).subscribe({
      next: (res: number[]) => {
        if (res) {
          if (res.some((r) => r == this.product.cartItem.productID)) {
            this.toastService.success('Thêm vào danh sách yêu thích!', '', {
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastService.success('Loại bỏ khỏi danh sách yêu thích!', '', {
              positionClass: 'toast-top-right',
            });
          }
          this.commonService.setWishlist(res);
        }
      },
      error: (error: any) => {
        this.toastService.error('Không thể cập nhật danh sách yêu thích!', '', {
          positionClass: 'toast-top-right',
        });
        console.log(error);
      },
    });
  }

  openVoucherModal(vouchers?: Voucher[], clickedCode?: string) {
    if (vouchers) {
      const codes = vouchers.map((v) => v.code);

      const uniqueCodes = clickedCode
        ? [clickedCode, ...codes.filter((code) => code !== clickedCode)]
        : codes;

      this.selectedVoucherCode = uniqueCodes;
    } else {
      this.selectedVoucherCode = [];
    }

    this.voucherModal.openModal();
  }

  gotoBlog() {
    this.commonService.gotoLink();
  }

  gotoPolicy(item: any) {
    if (item.direction) {
      this.router.navigateByUrl(item.direction);
    } else return;
  }
  // openRegistryModal(event: any) {
  //   if (event) {
  //     this.RegistryModal.openModal();
  //   }
  // }

  // openLoginModal(event: any) {
  //   if (event) {
  //     this.LoginModal.openModal();
  //   }
  // }

  // openForgotPasswordModal(event: any) {
  //   if (event) {
  //     this.ForgotPasswordModal.openModal();
  //   }
  // }
}
